module.exports = __webpack_public_path__ + "media/images/lb/626-bc7ee9fd6c64b7707dd0dfc7163a52e4.svg";